import AxiosInstance from "./apiClient";

export const sendAilmentResponse = async (response) => {
  const url = `ailment-responses`;
  try {
    const res = await AxiosInstance.post(url, response);

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

export const orderHerbsApi = async (orderData) => {
  const url = `orders`;
  try {
    const res = await AxiosInstance.post(url, orderData);

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

export const consultantPaymentApi = async (paymentData) => {
  const url = `payments/consultant`;
  try {
    const res = await AxiosInstance.post(url, paymentData);

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

export const saveConsentData = async (consentData) => {
  const url = `consent/create`;
  try {
    const res = await AxiosInstance.post(url, consentData);

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

// Creates a Stripe SetupIntent so we can save a card for future off-session
// charging without charging anything now.
export const createCardSetupIntentApi = async ({ userSubmissionId }) => {
  const url = `payments/card/setup-intent`;
  try {
    const res = await AxiosInstance.post(url, { userSubmissionId });

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};

// Completes card setup after Stripe confirmCardSetup succeeds
export const completeCardSetupApi = async ({ setupIntentId }) => {
  const url = `payments/card/setup-complete`;
  try {
    const res = await AxiosInstance.post(url, { setupIntentId });

    return res?.data;
  } catch (error) {
    console.log("Error", error);
    throw error;
  }
};


// Decline prescription review
export const declinePrescriptionApi = async (userSubmissionId) => {
  const url = `prescription-review/${userSubmissionId}/decline`;
  try {
    const res = await AxiosInstance.post(url);
    return res?.data;
  } catch (error) {
    console.log("Error declining prescription:", error);
    throw error;
  }
};

// Accept prescription review
export const acceptPrescriptionApi = async ({ userSubmissionId, addressId }) => {
  const url = `prescription-review/${userSubmissionId}/accept`;
  try {
    const res = await AxiosInstance.post(url, { addressId });
    return res?.data;
  } catch (error) {
    console.log("Error accepting prescription:", error);
    throw error;
  }
};

// Create new address
export const createAddressApi = async (addressData) => {
  const url = "address";
  try {
    const res = await AxiosInstance.post(url, addressData);
    return res?.data;
  } catch (error) {
    console.log("Error creating address:", error);
    throw error;
  }
};

// Create subscription checkout session
export const createSubscriptionCheckoutApi = async (data = {}) => {
  const url = "subscriptions/checkout";
  try {
    const res = await AxiosInstance.post(url, data);
    return res?.data;
  } catch (error) {
    console.log("Error creating subscription checkout session:", error);
    throw error;
  }
};

// Validate monthly subscription check-in token
export const validateCheckInTokenApi = async (token) => {
  const url = "subscription-check-in/validate-token";
  try {
    const res = await AxiosInstance.post(url, { token });
    return res?.data;
  } catch (error) {
    console.log("Error validating check-in token:", error);
    throw error;
  }
};

// Submit monthly subscription check-in form
export const submitCheckInFormApi = async (formData) => {
  const url = "subscription-check-in/submit";
  try {
    const res = await AxiosInstance.post(url, formData);
    return res?.data;
  } catch (error) {
    console.log("Error submitting check-in form:", error);
    throw error;
  }
};
